var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 256.000000 256.000000",
      "preserveAspectRatio": "xMidYMid meet"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
      "fill": _vm.primary,
      "stroke": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M788 2227 l-468 -172 0 -425 c0 -462 7 -554 55 -696 112 -333 417\n-612 822 -750 l81 -28 74 23 c40 13 120 45 177 72 342 161 586 427 669 729 36\n131 42 219 42 654 l0 423 -473 171 c-259 95 -481 172 -492 171 -11 -1 -230\n-78 -487 -172z m899 -139 l394 -143 -4 -410 c-3 -386 -4 -415 -25 -490 -86\n-309 -319 -548 -669 -685 l-102 -40 -63 24 c-185 69 -340 167 -469 296 -103\n103 -162 190 -210 314 -52 134 -59 210 -59 620 l0 371 388 141 c213 78 396\n142 406 143 11 1 197 -63 413 -141z"
    }
  }), _c('path', {
    attrs: {
      "d": "M1408 1363 l-288 -288 -128 128 c-70 70 -132 127 -138 127 -12 0\n-104 -92 -104 -105 0 -6 83 -93 185 -195 l185 -185 345 345 c190 190 345 350\n345 355 0 13 -92 105 -105 105 -6 0 -139 -129 -297 -287z"
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };